<template>
  <div class="container mx-auto">
    <template v-if="error.statusCode === 404">
      <div class="mt-16 mx-auto flex flex-col md:flex-row gap-10 place-items-center justify-center">
        <div>
          <img src="/images/undraw_under_construction_46pa.svg" width="200" class="m-auto mt-2" />
        </div>
        <div>
          <h1 class="text-2xl font-bold">Page non trouvée</h1>
          <div class="text-gray-500 font-light">{{ message ? message : "Vérifiez l'URL dans la barre d'adresse et réessayez" }}</div>
          <PdgButton class="mt-4" @click="clearError">Accueil</PdgButton>
        </div>
      </div>
    </template>
    <template v-else-if="error.statusCode === 408">
      <div class="mt-16 mx-auto flex flex-col md:flex-row gap-10 place-items-center justify-center">
        <div>
          <img src="/images/undraw_under_construction_46pa.svg" width="200" class="m-auto mt-2" />
        </div>
        <div>
          <h1 class="text-2xl font-bold">Temps de réponse dépassé</h1>
          <div class="text-gray-500 font-light">Nous sommes submergé de demandes 🌊, veuillez réessayer plus tard</div>
          <PdgButton class="mt-4" @click="clearError">Accueil</PdgButton>
        </div>
      </div>
    </template>

    <template v-else>
      <div class="mt-16 mx-auto flex flex-col md:flex-row gap-10 place-items-center justify-center">
        <div>
          <img src="/images/undraw_bug_fixing_oc7a.svg" width="200" class="m-auto mt-2" />
        </div>
        <div>
          <h1 class="text-2xl font-bold">Ouups ! une erreur est survenue...</h1>
          <PdgButton class="mt-4" @click="clearError">Accueil</PdgButton>
        </div>
      </div>
    </template>
    <template v-if="debug">
      <pre class="mt-5 border border-accent-500 border-solid text-left max-w-lg mx-auto p-5 text-sm overflow-x-scroll">{{ JSON.stringify(error) }}</pre>
    </template>
  </div>
</template>

<script setup lang="ts">
import type { NuxtError } from '#app';
import type { ApiPdg } from '~/plugins/api-pdg';

const props = defineProps<{
  error: NuxtError<ApiPdg.R.Base<void> | any>,
}>();

// const emits = defineEmits(['clearError']);

const { public: { debug } } = useRuntimeConfig();

const message = computed(() => props.error?.data?.data?.message);

function clearError() {
  navigateTo('/');
}

</script>
